// packages/agent-kit/src/public/public-agents/useMyQuotes.ts
import useSWR from 'swr';
import { quotesService, isApiError } from '@dopomogai/api-client';
import type { PaginatedResponse, QuoteSummary } from '@dopomogai/types';
import { AgentKitError } from '../../types';

const myQuotesFetcher = async ([, limit, offset]: [string, number, number]) => {
  const response = await quotesService.listMyQuotes(limit, offset);
  if (isApiError(response)) {
    throw new AgentKitError('Failed to fetch user quotes', response);
  }
  return response as PaginatedResponse<QuoteSummary>;
};

/**
 * A hook to fetch a paginated list of the authenticated user's quotes.
 */
export const useMyQuotes = (limit = 20, offset = 0) => {
  const swrKey = ['/quotes/my-quotes', limit, offset] as const;

  const { data, error, isLoading, mutate } = useSWR<
    PaginatedResponse<QuoteSummary>,
    AgentKitError
  >(swrKey, myQuotesFetcher, {
    keepPreviousData: true,
    revalidateOnFocus: false,
  });

  return {
    quotes: data?.items ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    mutate,
  };
};
